export default __webpack_public_path__ + "static/media/img1.0185ad7f.png";